import { render, staticRenderFns } from "./hotconsult.vue?vue&type=template&id=7ed056b0&scoped=true&"
import script from "./hotconsult.vue?vue&type=script&lang=js&"
export * from "./hotconsult.vue?vue&type=script&lang=js&"
import style0 from "./hotconsult.vue?vue&type=style&index=0&id=7ed056b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed056b0",
  null
  
)

export default component.exports